import React, { useState } from "react";
import {
  MobileStepper,
  MobileStepperFooter,
  MobileStepperBackButton,
  MobileStepperNextButton
} from "@sincro/react-mobile-stepper";
import { TrackedElement } from "@sincro/react-tracked-element";
import { AnnouncementCard } from "./Cards/AnnouncementCard";
import { makePascalCase, sanitizeText } from "./analytics/AnalyticsUtil";

const missingAnnouncement = {
  title: "NA"
};

export const Announcements = ({ announcements = [] }) => {
  const [activeIndex, setActive] = useState(0);
  const steps = announcements.length;
  const activeAnnouncement = announcements[activeIndex];
  const nextIndex = activeIndex + 1;
  const nextAnnouncement = announcements[nextIndex] || missingAnnouncement;
  const previousIndex = activeIndex - 1;
  const previousAnnouncement =
    announcements[previousIndex] || missingAnnouncement;

  return (
    <>
      {steps !== 0 ? (
        <MobileStepper>
          <AnnouncementCard
            title={activeAnnouncement.title}
            copy={activeAnnouncement.copy}
            externalLink={activeAnnouncement.externalLink}
            hyperlink={activeAnnouncement.hyperlink}
            image={activeAnnouncement.image}
            video={activeAnnouncement.video}
          />
          <MobileStepperFooter>
            <TrackedElement
              type={`show|${makePascalCase(
                sanitizeText(previousAnnouncement.title)
              )}`}
              name="DCC|Announcements"
            >
              <MobileStepperBackButton
                disabled={activeIndex === 0}
                onClick={() => setActive(previousIndex)}
                title={`${previousAnnouncement.title}`}
              >
                Back
              </MobileStepperBackButton>
            </TrackedElement>
            <span>
              {nextIndex} of {steps}
            </span>
            <TrackedElement
              type={`show|${makePascalCase(
                sanitizeText(nextAnnouncement.title)
              )}`}
              name="DCC|Announcements"
            >
              <MobileStepperNextButton
                disabled={activeIndex === steps - 1}
                onClick={() => setActive(nextIndex)}
                title={`${nextAnnouncement.title}`}
              >
                Next
              </MobileStepperNextButton>
            </TrackedElement>
          </MobileStepperFooter>
        </MobileStepper>
      ) : null}
    </>
  );
};
